import { ApplicationController } from "../application_controller";

// One piece of markup in two layouts: on phones and tablets the children of the element move into the container
// named by data-layout--mobileMove-to (a CSS selector), on a computer they come back. Nothing is rendered twice,
// the ids stay unique and the controllers inside reconnect as usual. The container holds nothing else: all that
// is in it comes back to the element. The element stays the home of the content, so the js responses that
// replace its innerHTML keep working: on phones and tablets the new content moves to the container again.
// Example: the partners of a deal — a column of the info tab on a computer, a tab of their own on a phone.
export default class extends ApplicationController {
  connect() {
    this.place(this.isMobileLayout);
    this.stopLayoutWatch = this.onMobileLayoutChange(mobile => this.place(mobile));
    this.observer = new MutationObserver(() => {
      if (this.isMobileLayout && this.element.firstChild) this.place(true);
    });
    this.observer.observe(this.element, { childList: true });
  }

  disconnect() {
    if (this.stopLayoutWatch) this.stopLayoutWatch();
    if (this.observer) this.observer.disconnect();
  }

  place(mobile) {
    const away = document.querySelector(this.data.get("to"));
    if (!away) return;

    if (mobile) {
      if (!this.element.firstChild) return;
      // the content that came to the element replaces the one moved away before
      while (away.firstChild) away.removeChild(away.firstChild);
      while (this.element.firstChild) away.appendChild(this.element.firstChild);
    } else {
      while (away.firstChild) this.element.appendChild(away.firstChild);
    }
  }
}
